import { makeAutoObservable } from 'mobx';
import { ColorScheme } from '@mantine/core';

const STORAGE_KEY = 'verybusy.colorScheme';

export default class ColorSchemeStore {
	colorScheme: ColorScheme;

	constructor() {
		this.colorScheme = ( localStorage.getItem( STORAGE_KEY ) as ColorScheme ) || 'light';
		makeAutoObservable( this );
	}

	setColorScheme = ( colorScheme: ColorScheme ) => {
		this.colorScheme = colorScheme;
		localStorage.setItem( STORAGE_KEY, colorScheme );
	}

	toggle = () => {
		this.setColorScheme( this.colorScheme === 'light' ? 'dark' : 'light' );
	}

	clear() {
		this.colorScheme = 'light';
		localStorage.removeItem( STORAGE_KEY );
	}
}
